import { PrimitiveAtom, useAtom } from 'jotai'

import { chatExamplesAtom, chatSettingsAtom, exampleTypeAtom, newQuestionAtom } from '@/store/gigiChat/ChatAtom'
import { IConversationSettings } from '@/types/gigiChat/ConversationSettings'
import { ITextExample } from '@/types/gigiChat/TextExamples'

import TextExamples from './TextExamples'

const Container = () => {
    const [chatSettings] = useAtom<PrimitiveAtom<IConversationSettings | null>>(chatSettingsAtom)
    const [, setQuestion] = useAtom<PrimitiveAtom<string | null>>(newQuestionAtom)
    const [textExamplesQuestion] = useAtom<PrimitiveAtom<Array<ITextExample>>>(chatExamplesAtom)
    const [exampleType] = useAtom<PrimitiveAtom<string>>(exampleTypeAtom)
    const qaExamples = textExamplesQuestion.find((item) => item.exampleType === 'QA')?.examples

    const getCorespondingExamples = (processingStrategy: string) => {
        if (textExamplesQuestion && textExamplesQuestion.length) {
            if (processingStrategy === 'QA') {
                const filteredExamples = textExamplesQuestion.find((item) => item.exampleType === exampleType)

                return filteredExamples?.examples.length ? filteredExamples.examples.flat() : qaExamples?.flat()
            } else {
                return textExamplesQuestion
                    .filter((item) => {
                        if (item.exampleType === processingStrategy) return item.examples
                    })
                    .map((elem) => elem.examples)
                    .flat()
            }
        }

        return []
    }

    const onNewQuestion = (question: string) => {
        setQuestion(question)
    }

    const values = chatSettings?.processingStrategy && getCorespondingExamples(chatSettings?.processingStrategy)

    if (chatSettings?.processingStrategy === 'Translation') {
        return null
    }

    return <TextExamples options={values} onNewQuestion={onNewQuestion} isClickable={chatSettings?.processingStrategy !== 'DocAnalysis'} />
}

export default Container
